export function getBrowserLanguage(getOnlyLanguage = true){
  return getOnlyLanguage
    ?
    navigator.language.split('-')[0]
    :
    navigator.language
}